import { render } from "./InactivityLogout.vue?vue&type=template&id=56cbca27"
import script from "./InactivityLogout.vue?vue&type=script&lang=js"
export * from "./InactivityLogout.vue?vue&type=script&lang=js"

import "./InactivityLogout.vue?vue&type=style&index=0&id=56cbca27&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__